import { render, staticRenderFns } from "./mikmak-module.vue?vue&type=template&id=6314c96d"
import script from "./mikmak-module.vue?vue&type=script&lang=js"
export * from "./mikmak-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports